import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface ClaimAdditionalInformationValue {
  additionalInformationId: string;
  value: string;
}

export interface SetClaimReasonAdditionalInformationCommandArgs {
  claimId: string;
  informations: ClaimAdditionalInformationValue[];
}

export const setClaimReasonAdditionalInformationRequest = ({
  claimId,
  informations,
}: SetClaimReasonAdditionalInformationCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/additionalInformation`,
  config: {
    method: SUPPORTED_METHODS.PUT,
    json: { additionalClaimInformation: informations },
  },
});

export const setClaimReasonAdditionalInformationCommand = async (
  args: SetClaimReasonAdditionalInformationCommandArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      setClaimReasonAdditionalInformationRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
